import React, { Component, useEffect, useState } from "react";
import Form from "../../comman/form";
import config from "../../config.json";
import Swal from "sweetalert2";
import Subcontractor from "./AddCandidate/Subcontractor";
import Candidate from "./AddCandidate/Candidate";
import Agency from "./AddCandidate/Agency";
import Msp from "./AddCandidate/Msp";
import Recruiter from "./AddCandidate/Recruiter";
import { useDispatch, useSelector, useStore } from "react-redux";
import {
  candidateBprmFormReceived,
  getCandidateBprmForm,
  getFilterCandidates,
  getSelectedCandidateObj,
  loadCandidateBprmForm,
  loadCandidatesByFilter,
  loadSelectedCandidatesByFilter,
} from "../../app/store/candidate";
import { getFieldData } from "../../services/appService";
import { getAlert } from "../../services/appAlerts";
import _ from "lodash";
import { getCurrentUser } from "../../app/store/auth";
import { getUpdateStatus, updateBprmForm } from "../../app/store/bprmForm";
import { getAllRates, loadAllRates } from "../../app/store/rates";

const AddCandidate = (props) => {
  const {
    selectedObj,
    actType,
    setSelectedTabKey,
    handleAddEditCandidate,
    selectedTabKey,
    setSelectedCandidateId,
    handleGoBack,
    onCandidateSaved,
  } = props;

  const getUpdateStatusData = useSelector(getUpdateStatus);
  const [selObjId, setSelObjId] = useState(null);
  const [rateHistory, setRateHistory] = useState([]);

  const currentUser = getCurrentUser();

  const candidateEntity = [
    { id: 1, name: "C2C Basis" },
    { id: 2, name: "W2 Basis" },
    { id: 3, name: "1099 Basis" },
  ];
  const w2Basis = [
    { id: 1, name: "W2 Hourly with Benefits" },
    { id: 2, name: "W2 Hourly with No-Benefits" },
  ];

  const [entityType, setEntityType] = useState(null);
  const [w2Type, setW2type] = useState(null);
  const [selectedKey, setSelectedKey] = useState("0");
  const [wfTask, setWfTask] = useState(null);
  const [wfId, setWfId] = useState(0);
  const [actionType, setActionType] = useState(actType);
  const [candidateObj, setCandidateObj] = useState(null);
  const [wfForm, setWfForm] = useState(null);
  const [aworkfinityApp, setAworkfinityApp] = useState(null);
  const [compType, setCompType] = useState("");

  const selectedCandidateObjSelector = useSelector(getSelectedCandidateObj);
  const candidateBprmFormSelector = useSelector(getCandidateBprmForm);
  const allRatesSelector = useSelector(getAllRates);

  const dispatch = useDispatch();
  useEffect(() => { }, [selectedTabKey]);

  useEffect(() => {
    if (selectedObj !== "" && actType === "edit") {
      setCandidateObj(selectedObj);
      const entType = getFieldData(
        selectedObj.performerData,
        "candidateonboardingform",
        "CandidateEntity"
      );
      const w9type = getFieldData(
        selectedObj.performerData,
        "candidateonboardingform",
        "w9_Type"
      );
      setEntityType(entType);
      setW2type(w9type);
      dispatch(candidateBprmFormReceived(null));
      setCandidateType(entType);
      setSelectedKey("0");
      dispatch(loadAllRates(selectedObj.performerid));
    } else {
      setEntityType("");
      setW2type(null);
      setWfTask(null);
      setWfId(0);
      setCandidateObj(null);
      setSelectedKey("0");
      dispatch(candidateBprmFormReceived(null));
    }
  }, [selectedObj, selectedTabKey]);

  useEffect(() => {
    if (allRatesSelector) setRateHistory(allRatesSelector);
  }, [allRatesSelector]);

  const handleSelectEntity = ({ currentTarget }) => {
    setEntityType(currentTarget.value);
    setCandidateType(currentTarget.value);
  };

  const setCandidateType = (entType) => {
    let appCiid = 0;
    if (selectedObj?.applications?.length > 0) {
      appCiid = selectedObj?.applications[0].ciid;
      // if (allWfTasks?.length > 0) {
      //   appCiid = allWfTasks[allWfTasks.length - 1].ciid;
      // }
    }

    if (entType === "C2C Basis") {
      setWfTask({ formId: config.formIds.candidate.C2C_Basis, ciid: appCiid });
      setWfId(config.workflowsIds.candidate.C2C_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.C2C_Basis));
    }
    if (entType === "W2 Basis") {
      setWfTask({ formId: config.formIds.candidate.W2_Basis, ciid: appCiid });
      setWfId(config.workflowsIds.candidate.W2_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.W2_Basis));
    }
    if (entType === "1099 Basis") {
      setWfTask({
        formId: config.formIds.candidate.Ten_99_Basis,
        ciid: appCiid,
      });
      setWfId(config.workflowsIds.candidate.Ten_99_Basis);
      dispatch(loadCandidateBprmForm(config.formIds.candidate.Ten_99_Basis));
    }
  };

  useEffect(() => {
    console.log(candidateBprmFormSelector);
    setWfForm(candidateBprmFormSelector);
  }, [candidateBprmFormSelector]);

  const activeTabs = [
    { key: "0", label: "Candidate", icon: "fa-user" },
    ...(entityType === "C2C Basis" ? [{ key: "1", label: "Subcontractor", icon: "fa-handshake-o" }] : []),
    { key: "2", label: "Recruiter", icon: "fa-user-plus" },
    { key: "3", label: "Agency/Client", icon: "fa-building" },
    { key: "4", label: "MSP", icon: "fa-cogs" }
  ];

  const getSavedCandidateId = () => candidateObj?.performerid || candidateObj?.id || 0;

  const handleBackToCandidateList = () => {
    if (actType === "edit") {
      handleGoBack();
      return;
    }

    const savedCandidateId = getSavedCandidateId();
    if (savedCandidateId > 0 && onCandidateSaved) {
      onCandidateSaved(savedCandidateId, { goHome: true });
      return;
    }
    handleGoBack();
  };

  useEffect(() => {
    if (!activeTabs.some((tab) => tab.key === selectedKey)) {
      setSelectedKey("0");
    }
  }, [entityType, selectedKey]);

  const setKey = (key) => {
    if (!candidateObj) {
      getAlert("", "Candidate not added", "warning");
      return;
    }
    if (key === "1" && entityType !== "C2C Basis") {
      getAlert("", "Subcontractor is only available for C2C candidates", "warning");
      return;
    }
    setSelectedKey(key);
  };

  const handleNextTab = (btnType) => {
    if (btnType !== "save" && btnType !== "exit") {
      const currentIndex = activeTabs.findIndex((tab) => tab.key === selectedKey);
      const nextTab = activeTabs[currentIndex + 1];
      if (nextTab) setSelectedKey(nextTab.key);
    }
    if (btnType === "exit") {
      handleBackToCandidateList();
    }
  };

  const updateBprmFormData = (selectedObj) => {
    if (aworkfinityApp == null) return;
    let appCiid = 0;
    if (selectedObj?.applications?.length > 0) {
      appCiid = selectedObj?.applications[0].ciid;
    }

    if (appCiid > 0) {
      const disValus = _.uniq(["candidateonboardingform"]);
      const frmData = new FormData();
      frmData.append("appEntity", JSON.stringify(aworkfinityApp));
      frmData.append("ciid", appCiid);
      frmData.append("ddTypes", disValus);

      if (entityType === "C2C Basis")
        frmData.append("formId", config.formIds.candidate.C2C_Basis);
      if (entityType === "W2 Basis")
        frmData.append("formId", config.formIds.candidate.W2_Basis);
      if (entityType === "1099 Basis")
        frmData.append("formId", config.formIds.candidate.Ten_99_Basis);

      frmData.append("performerId", currentUser.id);
      frmData.append("userName", currentUser.name);
      dispatch(updateBprmForm(frmData));
    }
    dispatch(loadAllRates(selectedObj.performerid));
  };

  const updateSelectedObject = async (id, wfData, type) => {
    const frmBody = new FormData();
    frmBody.append("id", id);
    frmBody.append("name", "");
    frmBody.append("email", "");
    frmBody.append("entity", "");
    frmBody.append("type", "candidate");
    frmBody.append("filterType", "single");
    dispatch(loadSelectedCandidatesByFilter(frmBody));
    if (wfData) {
      setAworkfinityApp(wfData);
      setCompType(type);
    }
  };

  useEffect(() => {
    if (getUpdateStatusData) {
      const frmBody = new FormData();
      frmBody.append("id", selObjId || 0);
      frmBody.append("name", "");
      frmBody.append("email", "");
      frmBody.append("entity", "");
      frmBody.append("type", "candidate");
      frmBody.append("filterType", "single");
      if (selObjId) {
        dispatch(loadSelectedCandidatesByFilter(frmBody));
      }
    }
  }, [getUpdateStatusData]);

  useEffect(() => {
    if (selectedCandidateObjSelector.length > 0) {
      const selectedCandidate = selectedCandidateObjSelector[0];
      setCandidateObj(selectedCandidate);
      updateBprmFormData(selectedCandidate);
      setActionType("edit");
      if (onCandidateSaved) {
        onCandidateSaved(selectedCandidate.performerid || selectedCandidate.id, { goHome: false });
      } else {
        handleAddEditCandidate();
      }
    }
  }, [selectedCandidateObjSelector]);

  const getTabHeader = (key) => {
    switch (key) {
      case "0":
        return {
          title: "Candidate Profile Details",
          sub: "Configure onboarding information and personal details for this candidate.",
          icon: "fa-user"
        };
      case "1":
        return {
          title: "Subcontractor Configuration",
          sub: "Assign subcontractors to this candidate and configure hourly payment rates.",
          icon: "fa-handshake-o"
        };
      case "2":
        return {
          title: "Recruiter Engagement details",
          sub: "Set up recruiter profiles, rates, and engagement options.",
          icon: "fa-user-plus"
        };
      case "3":
        return {
          title: "Agency Engagement details",
          sub: "Configure agency rates, position titles, locations, and contact info.",
          icon: "fa-building"
        };
      case "4":
        return {
          title: "MSP Administration & Fees",
          sub: "Configure MSP modes, admin fees, company hub percentages, and notes.",
          icon: "fa-cogs"
        };
      default:
        return null;
    }
  };

  return (
    <>
      <style>{`
        @keyframes asFadeIn {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        .wf-add-candidate-container {
          border: 1px solid rgba(226, 232, 240, 0.9) !important;
          border-radius: 20px !important;
          background: #ffffff !important;
          box-shadow: 0 18px 45px rgba(15, 23, 42, 0.07) !important;
          margin-top: 10px !important;
          animation: asFadeIn 0.3s ease both !important;
          overflow: hidden !important;
        }

        /* ── Form Header ── */
        .wf-add-candidate-container .as-form-header {
          display: flex !important;
          align-items: flex-start !important;
          justify-content: space-between !important;
          flex-wrap: wrap !important;
          gap: 18px !important;
          padding: 22px 24px 18px !important;
          background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%) !important;
          border-bottom: 1px solid rgba(226, 232, 240, 0.9) !important;
          position: relative !important;
          overflow: hidden !important;
          margin: 0 !important;
          width: 100% !important;
          border-radius: 20px 20px 0 0 !important;
        }
        .as-form-header-left {
          display: flex !important;
          align-items: flex-start !important;
          gap: 14px !important;
          min-width: 260px !important;
          flex: 1 1 360px !important;
        }
        .as-form-header-right {
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
          flex-wrap: wrap !important;
          justify-content: flex-end !important;
          margin-left: auto !important;
          position: relative !important;
          z-index: 1 !important;
          flex-shrink: 0 !important;
        }
        .as-header-back-btn {
          background: #ffffff !important;
          border: 1.5px solid #cbd5e1 !important;
          border-radius: 8px !important;
          padding: 6px 14px !important;
          color: #475569 !important;
          font-size: 12.5px !important;
          font-weight: 600 !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
          cursor: pointer !important;
          transition: all 0.2s ease !important;
          box-shadow: 0 1px 3px rgba(0,0,0,0.05) !important;
          outline: none !important;
          height: 38px !important;
        }
        .as-header-back-btn:hover {
          background: #f1f5f9 !important;
          border-color: #94a3b8 !important;
          color: #0f172a !important;
          transform: translateY(-1px) !important;
        }
        .as-form-header-icon {
          width: 44px !important;
          height: 44px !important;
          border-radius: 12px !important;
          background: linear-gradient(135deg, #2563eb 0%, #0284c7 100%) !important;
          border: 1px solid rgba(37, 99, 235, 0.18) !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #ffffff !important;
          font-size: 18px !important;
          flex-shrink: 0 !important;
          box-shadow: 0 12px 22px rgba(15, 23, 42, 0.16) !important;
        }
        .as-form-header-text {
          position: relative !important;
          z-index: 1 !important;
        }
        .as-form-header-title {
          color: #0f172a !important;
          font-size: 16px !important;
          font-weight: 800 !important;
          margin: 0 !important;
          line-height: 1.2 !important;
        }
        .as-form-header-sub {
          color: #64748b !important;
          font-size: 13px !important;
          margin-top: 6px !important;
          font-weight: 500 !important;
          max-width: 620px !important;
        }
        .as-form-header-meta {
          display: flex !important;
          align-items: center !important;
          gap: 7px !important;
          flex-wrap: wrap !important;
          margin-top: 10px !important;
        }
        .as-meta-pill {
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          padding: 4px 12px !important;
          border-radius: 99px !important;
          background: #ffffff !important;
          border: 1px solid #cbd5e1 !important;
          color: #475569 !important;
          font-size: 12px !important;
          font-weight: 700 !important;
          height: auto !important;
          line-height: 1.5 !important;
        }
        .as-meta-pill i { font-size: 11px !important; }
        .as-meta-pill.meta-id i {
          color: #1d4ed8 !important;
        }
        .as-meta-pill.meta-person i {
          color: #047857 !important;
        }
        .as-meta-pill.meta-email i {
          color: #0369a1 !important;
        }
        .as-meta-pill.meta-entity i {
          color: #6d28d9 !important;
        }
        .as-meta-pill.meta-benefits i {
          color: #b45309 !important;
        }
        .as-meta-pill.meta-ciid i {
          color: #0f766e !important;
        }

        /* ── Form Body ── */
        .as-form-body {
          padding: 24px !important;
          background: #f8fafc !important;
          border-bottom: 1.5px solid #f1f5f9 !important;
        }
        .as-form-body .form-control:disabled,
        .as-form-body .form-control[disabled] {
          background: #f8fafc !important;
          border-color: #dbe3ee !important;
          color: #1e293b !important;
          cursor: not-allowed !important;
          opacity: 1 !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
        }

        .as-form-body .form-control:disabled:focus,
        .as-form-body .form-control[disabled]:focus {
          border-color: #dbe3ee !important;
          box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04) !important;
          background: #f8fafc !important;
        }

        .as-form-body .wf-input-wrap:has(.form-control:disabled) .wf-input-icon,
        .as-form-body .wf-input-wrap:has(.form-control[disabled]) .wf-input-icon {
          color: #94a3b8 !important;
        }

        /* ── Modern Rich UI Custom Tabs (enhanced like document tab) ── */
        .wf-custom-tabs-container {
          margin-bottom: 24px !important;
          width: 100% !important;
          position: relative !important;
        }
        .wf-custom-tabs-list {
          list-style: none !important;
          margin: 0 !important;
          padding: 8px 4px 0 !important;
          display: flex !important;
          align-items: stretch !important;
          gap: 4px !important;
          width: 100% !important;
          border-bottom: 2px solid #f1f5f9 !important;
          position: relative !important;
        }
        .wf-custom-tab-item {
          margin: 0 !important;
          padding: 0 !important;
        }
        .wf-custom-tab-link {
          background: transparent !important;
          border: none !important;
          outline: none !important;
          box-shadow: none !important;
          padding: 9px 16px 11px !important;
          font-size: 13.5px !important;
          font-weight: 600 !important;
          color: #64748b !important;
          cursor: pointer !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 7px !important;
          white-space: nowrap !important;
          transition: color 0.2s ease, background 0.2s ease !important;
          position: relative !important;
          user-select: none !important;
          border-radius: 8px 8px 0 0 !important;
        }
        .wf-custom-tab-link::after {
          content: '' !important;
          position: absolute !important;
          bottom: -2px !important;
          left: 0 !important;
          right: 0 !important;
          height: 2px !important;
          border-radius: 2px 2px 0 0 !important;
          background: #2563eb !important;
          transform: scaleX(0) !important;
          transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
        }
        .wf-custom-tab-link:hover {
          color: #1e293b !important;
          background: rgba(37, 99, 235, 0.04) !important;
        }
        .wf-custom-tab-link.active {
          color: #2563eb !important;
          font-weight: 700 !important;
          background: transparent !important;
        }
        .wf-custom-tab-link.active:hover {
          background: transparent !important;
        }
        .wf-custom-tab-link.active::after {
          transform: scaleX(1) !important;
        }
        .wf-custom-tab-link:focus,
        .wf-custom-tab-link:active,
        .wf-custom-tab-link:focus-visible {
          outline: none !important;
          border: none !important;
          box-shadow: none !important;
        }
        .wf-custom-tab-link i {
          font-size: 13px !important;
          transition: color 0.2s ease !important;
          color: #64748b !important;
        }
        .wf-custom-tab-link:hover i {
          color: #1e293b !important;
        }
        .wf-custom-tab-link.active i {
          color: #2563eb !important;
        }

        /* Responsive adjustments for Custom Tabs */
        @media (max-width: 768px) {
          .wf-custom-tabs-list {
            width: 100% !important;
            overflow-x: auto !important;
            flex-wrap: nowrap !important;
            padding-bottom: 6px !important;
          }
          .wf-custom-tab-link {
            padding: 10px 14px 12px !important;
            font-size: 13px !important;
          }
        }

        .wf-tab-content-container {
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 12px;
          padding: 24px;
          margin-top: 12px;
        }

        .wf-tab-inner-header {
          display: flex !important;
          align-items: center !important;
          gap: 12px !important;
          padding: 12px 16px !important;
          background: #f8fafc !important;
          border: 1px solid #e2e8f0 !important;
          border-radius: 8px !important;
          margin-bottom: 20px !important;
        }
        .wf-tab-inner-icon {
          width: 32px !important;
          height: 32px !important;
          border-radius: 6px !important;
          background: #eff6ff !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          color: #2563eb !important;
          font-size: 14px !important;
          flex-shrink: 0 !important;
        }
        .wf-tab-inner-text {
          display: flex !important;
          flex-direction: column !important;
          gap: 2px !important;
        }
        .wf-tab-inner-title {
          font-size: 13px !important;
          font-weight: 800 !important;
          color: #0f172a !important;
          margin: 0 !important;
          text-transform: uppercase !important;
          letter-spacing: 0.5px !important;
        }
        .wf-tab-inner-sub {
          font-size: 12px !important;
          font-weight: 500 !important;
          color: #64748b !important;
          margin: 0 !important;
          line-height: 1.4 !important;
        }

        /* ── Form Footer ── */
        .as-form-footer {
          display: flex !important;
          align-items: center !important;
          justify-content: flex-end !important;
          gap: 10px !important;
          flex-wrap: wrap !important;
          padding: 14px 22px !important;
          border-top: 1.5px solid #f1f5f9 !important;
          background: #fafbfd !important;
        }
      `}</style>

      <div className="wf-add-candidate-container">
        {/* ── Form Header ── */}
        <div className="as-form-header">
          <div className="as-form-header-left">
            <div className="as-form-header-icon">
              <i className={`fa ${actionType === "edit" ? "fa-pencil-square-o" : "fa-user-plus"}`} />
            </div>
            <div className="as-form-header-text">
              <p className="as-form-header-title">
                {actionType === "edit"
                  ? "Edit Candidate Details"
                  : "Add New Candidate Partner"}
              </p>
              <p className="as-form-header-sub">
                {actionType === "edit"
                  ? `Updating profile and system configurations for candidate: ${selectedObj?.performername || ""} ${selectedObj?.lastName || ""}`
                  : "Fill in the details below to register and onboard a new candidate application"}
              </p>
              <div className="as-form-header-meta">
                <span className="as-meta-pill meta-id">
                  <i className="fa fa-id-badge" /> ID: {selectedObj?.performerid || "New"}
                </span>
                {actionType === "edit" && selectedObj?.performername && (
                  <span className="as-meta-pill meta-person">
                    <i className="fa fa-user" /> {selectedObj.performername} {selectedObj.lastName}
                  </span>
                )}
                {actionType === "edit" && selectedObj?.performeremail && (
                  <span className="as-meta-pill meta-email">
                    <i className="fa fa-envelope-o" /> {selectedObj.performeremail}
                  </span>
                )}
                {entityType && (
                  <span className="as-meta-pill meta-entity">
                    <i className="fa fa-building" /> {entityType}
                  </span>
                )}
                {w2Type && (
                  <span className="as-meta-pill meta-benefits">
                    <i className="fa fa-gift" /> {w2Type}
                  </span>
                )}
                {wfTask?.ciid > 0 && (
                  <span className="as-meta-pill meta-ciid">
                    <i className="fa fa-hashtag" /> CIID {wfTask.ciid}
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="as-form-header-right">
            <button
              type="button"
              className="as-header-back-btn"
              onClick={handleBackToCandidateList}
            >
              <i className="fa fa-arrow-left" aria-hidden="true" />
              Back
            </button>
          </div>
        </div>

        {/* ── Form Body ── */}
        <div className="as-form-body">
          <div className="row">
            <div className="col-lg-12 form-group mb-3">
              <label htmlFor="CandidateEntity" className="wf-control-label">
                <i className="fa fa-building" /> Candidate Entity
              </label>
              <div className="wf-input-wrap">
                <i className="fa fa-building wf-input-icon" aria-hidden="true" />
                <select
                  name="CandidateEntity"
                  id="CandidateEntity"
                  className="form-control wf-input wf-select"
                  onChange={handleSelectEntity}
                  value={entityType}
                  disabled={actType === "edit"}
                >
                  <option value="">Select Candidate Entity</option>
                  {candidateEntity.map((item) => (
                    <option key={item.id} value={item.name}>{item.name}</option>
                  ))}
                </select>
              </div>
            </div>

            {entityType === "W2 Basis" && (
              <div className="col-md-12 form-group mb-3">
                <label htmlFor="w9_Type" className="wf-control-label">
                  <i className="fa fa-gift" /> Select Benefits
                </label>
                <div className="wf-input-wrap">
                  <i className="fa fa-gift wf-input-icon" aria-hidden="true" />
                  <select
                    name="w9_Type"
                    id="w9_Type"
                    className="form-control wf-input wf-select"
                    onChange={({ currentTarget }) => setW2type(currentTarget.value)}
                    value={w2Type}
                  >
                    <option value="">Select Benefits</option>
                    {w2Basis.map((item) => (
                      <option key={item.id} value={item.name}>{item.name}</option>
                    ))}
                  </select>
                </div>
              </div>
            )}

            {entityType && (
              <div className="col-md-12 mt-3">
                <div className="wf-custom-tabs-container">
                  <div className="wf-custom-tabs-list">
                    {activeTabs.map((tab) => (
                      <button
                        key={tab.key}
                        type="button"
                        className={`wf-custom-tab-link${selectedKey === tab.key ? " active" : ""}`}
                        onClick={() => setKey(tab.key)}
                      >
                        <i className={`fa ${tab.icon}`} /> {tab.label}
                      </button>
                    ))}
                  </div>
                </div>

                <div className="wf-tab-content-container" style={{ height: "calc(60vh)", overflowY: "auto" }}>
                  {getTabHeader(selectedKey) && (
                    <div className="wf-tab-inner-header">
                      <div className="wf-tab-inner-icon">
                        <i className={`fa ${getTabHeader(selectedKey).icon}`} />
                      </div>
                      <div className="wf-tab-inner-text">
                        <h4 className="wf-tab-inner-title">{getTabHeader(selectedKey).title}</h4>
                        <p className="wf-tab-inner-sub">{getTabHeader(selectedKey).sub}</p>
                      </div>
                    </div>
                  )}
                  {selectedKey === "0" && (
                    <Candidate
                      updateSelectedObject={updateSelectedObject}
                      candidateObj={candidateObj}
                      handleNextTab={handleNextTab}
                      entityType={entityType}
                      w2Type={w2Type}
                      wfId={wfId}
                      wfTask={wfTask}
                      wfForm={wfForm}
                      actionType={actionType}
                      actType={actType}
                      rateHistory={rateHistory}
                      disabledFieldIds={actType === "edit" ? ["candidateonboardingform.IPCS_Existing_ID", "IPCS_Existing_ID"] : []}
                    />
                  )}

                  {selectedKey === "1" && entityType === "C2C Basis" && (
                    <Subcontractor
                      candidateObj={candidateObj}
                      entityType={entityType}
                      handleNextTab={handleNextTab}
                      updateSelectedObject={updateSelectedObject}
                      actType={actType}
                      rateHistory={rateHistory}
                    />
                  )}

                  {selectedKey === "2" && (
                    <Recruiter
                      candidateObj={candidateObj}
                      handleNextTab={handleNextTab}
                      updateSelectedObject={updateSelectedObject}
                      actType={actType}
                      rateHistory={rateHistory}
                    />
                  )}

                  {selectedKey === "3" && (
                    <Agency
                      candidateObj={candidateObj}
                      handleNextTab={handleNextTab}
                      updateSelectedObject={updateSelectedObject}
                      actType={actType}
                      rateHistory={rateHistory}
                    />
                  )}

                  {selectedKey === "4" && (
                    <Msp
                      candidateObj={candidateObj}
                      updateSelectedObject={updateSelectedObject}
                      actType={actType}
                      setSelectedTabKey={setSelectedTabKey}
                      setSelectedCandidateId={setSelectedCandidateId}
                      handleNextTab={handleNextTab}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        </div>

        {/* ── Form Footer ── */}
        <div className="as-form-footer">
          <button
            type="button"
            className="btn-action-search btn-danger-search"
            onClick={handleBackToCandidateList}
          >
            <i className="fa fa-arrow-left" aria-hidden="true" />
            Back to Candidates
          </button>
        </div>
      </div>
    </>
  );
};

export default AddCandidate;
